<!-- Brand -->
<div class="row bg-light px-4 pt-4 pb-2">
    <img [src]="logoPath" class="col-4" alt="Logo">
    <div class="col"></div>
    <div class="col-auto justify-content-center d-flex flex-column">
        <h2>{{header}}</h2>
    </div>
</div>
